import * as React from "react";
import {cs} from "../../../../../../../../../../../../react/chain-services";
import "./zip-codes.scss";
import {Checkbox} from "../../../../../../../../../../common/design2/checkbox/checkbox";
import {UseState} from "../../../../../../../../../../../../react/use-state";
import {cx} from "emotion";

export const ZipCodes = ({list, isSelected, style=undefined, onSelect, onSelectAll, onUnselectAll, onClose=undefined}) => cs(
    ["collapsed", (_, next) => UseState({next})],
    ({collapsed}) => (
        <div className={cx("zip-codes-64q", {collapsed: collapsed.value}, style?.color)}>
            <div 
                className="toggle"
                onClick={() => {
                    if (!collapsed.value && onClose) {
                        onClose();
                    }
                    collapsed.change((_) => !_)
                }}
            >
                {Checkbox({
                    size: "small",
                    ...!list.find(isSelected) ? {
                        checked: false,
                        onClick: (e) => {
                            e.stopPropagation();
                            onSelectAll();
                        },
                    } : !list.find((i) => !isSelected(i)) ? {
                        checked: true,
                        onClick: (e) => {
                            e.stopPropagation();
                            onUnselectAll();
                        },
                    } : {
                        checked: "midway",
                        onClick: (e) => {
                            e.stopPropagation();
                            onSelectAll();
                        },
                    },
                    xdQaName: "New Homeowners Zip Code"
                })}
                <div className="text" xd-qa-type="label" xd-qa-name="New Homeowners Zip Code">
                    ZIP CODE
                </div>
                {(() => {
                    const selecteds = list.filter(isSelected);
                    return !!selecteds.length && (
                        <div className="count" xd-qa-type="label" xd-qa-name="New Homeowners Zip Code Count">
                            ({selecteds.length})
                        </div>
                    );
                })()}
                <div className="collapse-indicator">
                    <i className={cx("fa", collapsed.value ? "fa-caret-up" : "fa-caret-down")}/>
                </div>
            </div>
            {!collapsed.value && (
                <div className="list">
                    {list.map((item, i) => (
                        <div className="item" key={i} onClick={() => onSelect(item)}>
                            {Checkbox({
                                checked: isSelected(item),
                                size: "small",
                                xdQaName: "New Homeowners Zip Code "+item,
                            })}
                            <div className="text" xd-qa-type="dropdown_item" xd-qa-name={"New Homeowners Zip Code "+item}>
                                {item}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    ),
);
